import React from "react";

const Loader = ({ size, color = "dark-text" }) => {
  const sizeClass =
    size === "small"
      ? "spinner-border-sm fs-small-k"
      : size === "medium"
      ? "spinner-border-md fs-normal-k"
      : size === "large"
      ? "spinner-border-lg fs-med-k"
      : "";

  return (
    <div className="d-flex w-full-k justify-content-center align-items-center">
      <div className={`spinner-border ${sizeClass} ${color}`} role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};

// Loader.propTypes = {
//   size: PropTypes.oneOf(["small", "medium", "large"])
// };

export default Loader;